const state = {
  data: [],
  orderables: [
  {
    title: 'Nome',
    name: 'arquivo_nome'
  },
  {
    title: 'Cadastrado em',
    name: 'created_at'
  }
],
filterGroups: [{
  name: 'Arquivo',
  filters: [{
      title: 'Nome',
      name: 'arquivo_nome',
      type: 'string'
    },
    {
      title: 'Cadastrado em',
      name: 'created_at',
      type: 'datetime'
    }
  ]
}]
};

const mutations = {
  SET_HISTORY: (state, payload) => {
    state.data = payload;
  },
  ADD_HISTORY: (state, payload) => {
    state.data.push(...payload);
  },
};

const actions = {
  setHistory: (context, payload) => {
    context.commit('SET_HISTORY', payload);
  },
};
export default {
  state,
  mutations,
  actions
};